import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { Subject, map, takeUntil } from 'rxjs';
import { ThemeType } from 'src/app/shared/models';
import { ConfigService, CurrentFacilityService, ThemeService } from 'src/app/shared/services';
import { SectionLogo } from '../../models/section-logo';

@Component({
    standalone: true,
    selector: 'app-facility-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss'],
    imports: [CommonModule, MatButtonModule, RouterModule, NgOptimizedImage],
})
export class LogoFacilityComponent implements OnInit, OnDestroy {
    private unsubscribe$: Subject<void>;
    public defaultLogo: string;
    public sectionLogo = SectionLogo;

    @Input() height = '';
    @Input() width = '';
    @Input() redirectURL: string;
    @Input() mode?: ThemeType;
    @Input() context?: SectionLogo;
    @Input() priority = false;

    constructor(
        private themeService: ThemeService,
        private configService: ConfigService,
        private currentFacilityService: CurrentFacilityService
    ) {
        this.unsubscribe$ = new Subject<void>();
    }

    ngOnInit(): void {
        if (!this.mode) {
            this.subscribeTheme();
        } else {
            this.defaultLogo = this.getLogoByMode(this.mode);
        }
        this.setLogoDimensions();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    getLogoByMode(mode: ThemeType): string {
        if (this.currentFacilityService.getAlternativeLogoToLogin()) {
            return this.currentFacilityService.getAlternativeLogoByMode(mode);
        }
        return this.currentFacilityService.getMainLogoByMode(mode);
    }

    subscribeTheme(): void {
        this.themeService
            .getTheme()
            .pipe(
                map((theme: ThemeType) => this.getLogoByMode(theme)),
                takeUntil(this.unsubscribe$)
            )
            .subscribe((logo) => (this.defaultLogo = logo));
    }

    private setLogoDimensions(): void {
        const isFooterLogo = this.context === SectionLogo.footer;
        const logoHeight = isFooterLogo
            ? this.configService.getFooterLogoHeight()
            : this.currentFacilityService.getLogoHeightForLogin();
        const logoWidth = isFooterLogo
            ? this.configService.getFooterLogoWidth()
            : this.currentFacilityService.getLogoWidthForLogin();
        if (logoHeight && logoHeight !== 'auto') {
            this.height = logoHeight;
        }
        if (logoWidth && logoWidth !== 'auto') {
            this.width = logoWidth;
        }
    }
}
